// src/components/Navbar/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import rdvWhite from '../../assets/rdv-logoW.png';
import rdvBlack from '../../assets/rdv-logoB.png';
import { useFileContext } from '../../ContextAPI/FileContext';

const Navbar = () => {
  const { auth, logout } = useFileContext();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className={`Navbar_Container ${isHomePage ? 'transparent' : 'white'}`}>
        <nav className={`navbar ${isHomePage ? 'transparent' : 'white'} ${isScrolled ? 'scrolled' : ''}`}>
          <div className='navbar-logo'>
            <img className='rdvImageNav' src={isHomePage ? rdvWhite : rdvBlack} alt='rdv' />
          </div>
          
          <div className='navbar-links'>
            <Link to="/" className="navbar-link">Home</Link>
            <Link to="/about" className="navbar-link">About</Link>
            <Link to="/services" className="navbar-link">Services</Link>
            <Link to="/contact" className="navbar-link">Contact</Link>
          </div>
          
          <div className='navbar-login'>
            {auth ? (
              <button className="login-btn" onClick={logout}>
                <svg className="login-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Logout
              </button>
            ) : (
              <Link to="/login" className="login-btn">
                <svg className="login-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Login
              </Link>
            )}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
